import { usePanelActionsInternal } from './panel-provider';

/**
 * Convenience hook to access only the panel manager actions.
 * Use this if you don't need the state to avoid unnecessary re-renders.
 *
 * @throws {Error} If called outside of a PanelProvider
 *
 * @example
 * ```tsx
 * function OpenButton() {
 *   const manager = usePanelActions();
 *   // This component won't re-render when panels open/close/resize
 *   return (
 *     <button onClick={() => manager.openPanel('id-1', entryPoint)}>
 *       Open
 *     </button>
 *   );
 * }
 * ```
 */
export const usePanelActions: typeof usePanelActionsInternal = usePanelActionsInternal;
